import React ,{useState , useEffect} from "react";
import { CommonCharts } from "../CommonCharts/CommonCharts";
import Commonrecords from "../Commonrecords/Commonrecords";
import { useDispatch, useSelector } from "react-redux";
import {clearCustomerSupportStateList ,clearCustomerSupportStateChart } from "../../../../../../../../Redux/Slice"


export default function StateTabContent({
      datas,
  PriorityValues,
  SttausValues,
  Client,
  date,
  range
}) {
    const dashboardData = useSelector((state) => state.CustomerSupportStateList.CustomerSupportStateListData);
    const stateCharts = useSelector((state) => state.CustomerSupportStateChart.CustomerSupportStateChartData);
    const state = useSelector((state) => state);
     const dispatch = useDispatch();
  const [search, setSearch] = useState("");
let isValidRange =
  Array.isArray(range) &&
  range.length > 0 &&
  range.every((date) => !!date && date !== "NaN-aN-aN");



  useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){
         const payload ={
                region: datas.region,
                zone: datas.zone,
                client:Client,
                               search:search,
                priority:PriorityValues, 
      from_date: range[0],
      to_date: range[1],
      range: isValidRange,
date:date,
                          state:datas.state

            }
         dispatch(clearCustomerSupportStateList(payload))
    }
    },[datas  ,Client  ,PriorityValues , date ,search ,range])


   useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){
         const payload ={
                region: datas.region,
                zone: datas.zone,
                client:Client,
                                       date:date,
                priority:PriorityValues, 
      from_date: range[0],
      to_date: range[1],
      range: isValidRange,
              date:date,
                            state:datas.state

              }
         dispatch(clearCustomerSupportStateChart(payload))
    }
    },[datas  ,Client  ,PriorityValues ,date ,range ])


// console.log(state.CustomerSupportStateChart.CustomerSupportStateChartData);




const allIssues = dashboardData.map((item) => ({
  id: item.client_id__state_id__id,
  name: item.client_id__state_id__state_name,
  count: item.group_tickets,
}));


const tamilnaduData = stateCharts.map(item => ({
value: item.ticket_percentage != null
  ? parseFloat(item.ticket_percentage.toFixed(2))
  : 0,
  name: item.client_id__state_id__state_name.toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) // Proper Case
}));


  return (
    <div className="chart-list-row_state">

  <div className="Chart_design">

        <CommonCharts title="Top 5 Issue State" data={tamilnaduData} 
        
         />
  </div>

<div className="Listed_datas">

  <Commonrecords allIssues={allIssues}  title={"States List"} 
   Table_names={"state"}
  search={search} setSearch={setSearch}
  />

</div>
    </div>
  );
}
